import { useQuery } from '@abyss/web/hooks/useQuery';
import { ApiUrl } from '@src/common/ajax/apiUrl';
import GetProviderGlobalSearch from './GetProviderGlobalSearch.gql';

export const useGetProviderGlobalSearch = (options) => {
  return useQuery(GetProviderGlobalSearch, {
    ...options,
    url: ApiUrl.graphQl(),
    headers: {
      'Accept-Encoding': 'gzip, deflate, br',
    },
  });
};
